<template>
  <div class="appointment">
    <el-alert :title="$t('deliveryappointment.urgentreservation.warningTip')" type="warning" show-icon />
    <div class="appointment-header">
      <div class="appointment-top">
        <el-form inline style="width: max-content;">
          <el-form-item :label="$t('deliveryappointment.urgentreservation.date')">
            <el-date-picker
              v-model="time.date"
              :disabled="!dateList.length"
              value-format="yyyy-MM-dd"
              type="date"
              :picker-options="pickerOptions"
              :clearable="false"
            />
          </el-form-item>

          <el-form-item :label="$t('deliveryappointment.urgentreservation.startTime')">
            <el-select
              v-model="time.startTime"
              :disabled="!time.date"
              @change="changeStartTime"
            >
              <el-option
                v-for="item in timeOptions"
                :key="item.startTime"
                :label="item.startTime"
                :value="item.startTime"
              />
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('deliveryappointment.urgentreservation.endTime')">
            <el-select
              v-model="time.endTime"
              :disabled="!time.date"
              @change="changeEndTime"
            >
              <el-option
                v-for="item in timeOptions"
                :key="item.endTime"
                :label="item.endTime"
                :value="item.endTime"
              />
            </el-select>
          </el-form-item>

        </el-form>
        <div style="width: max-content;">
          <span style="margin-right: 15px;">已选择 <span style="color: #008ee3;">{{ carSelection.length }}</span> 个卸货点</span>
          <el-button @click="$router.back()">取消</el-button>
          <el-button type="success" @click="submit()">稍后完善</el-button>
          <el-button type="primary" @click="submit(true)">继续完善信息</el-button>
        </div>
      </div>

      <div class="appointment-tabs">
        <div class="appointment-tabs-list">
          <el-button type="text" round>公司</el-button>
          <el-button
            :type="purchaseUnitNo === '' ? 'primary' : 'text'"
            :plain="purchaseUnitNo === ''"
            round
            @click="changePurchaseUnitNo('')"
          >全部</el-button>
          <el-button
            v-for="(item, index) in purchaseUnits"
            :key="index"
            :type="purchaseUnitNo === item.purchaseUnitNo ? 'primary' : 'text'"
            :plain="purchaseUnitNo === item.purchaseUnitNo"
            round
            @click="changePurchaseUnitNo(item.purchaseUnitNo)"
          >{{ item.purchaseUnitName }}</el-button>
        </div>

        <div class="appointment-tabs-list">
          <el-button type="text" round>仓库</el-button>
          <el-button
            :type="receiptWareId === '' ? 'primary' : 'text'"
            :plain="receiptWareId === ''"
            round
            @click="changeReceiptWareId('')"
          >全部</el-button>
          <el-button
            v-for="(item, index) in receiptWares"
            :key="index"
            :type="receiptWareId === item.receiptWareId ? 'primary' : 'text'"
            :plain="receiptWareId === item.receiptWareId"
            round
            @click="changeReceiptWareId(item.receiptWareId)"
          >{{ item.receiptWareName }}</el-button>
        </div>
      </div>

    </div>

    <div class="appointment-list">
      <CardItem
        v-for="(item, index) in list"
        :key="index"
        :data="item"
        :selection="selection"
        :selection-map="selectionMap"
        :append-to-body="false"
        placement="right-start"
        @change="selection = $event"
        @change-car="changeCar"
      />
    </div>

    <div v-if="total && total > size" class="appointment-footer">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        :current-page="current"
        :page-size="size"
        :page-sizes="[6, 12, 18, 30]"
        :total="total"
        @current-change="currentChange"
        @size-change="sizeChange"
      />
    </div>
  </div>
</template>

<script>
import http from '@/plugin/axios'
import { formatDate } from '@utils/common/index'
import CardItem from './components/card-item'
export default {
  components: {
    CardItem
  },
  data() {
    return {
      baseInfo: { dateList: [] },
      time: {
        date: '',
        startTime: '',
        endTime: ''
      },
      current: 1,
      size: 12,
      total: 0,
      purchaseUnitNo: '',
      receiptWareId: '',
      timeOptions: [],
      purchaseUnits: [],
      receiptWares: [],
      info: {},
      carSelection: [],
      selection: []
    }
  },
  computed: {
    selectionMap() {
      return new Set(this.selection)
    },
    dateList() {
      return this.baseInfo.dateList || []
    },
    dateMap() {
      return new Map(this.dateList.map(item => [item.date, item]))
    },
    pickerOptions() {
      if (!this.dateList.length) return {}
      return {
        disabledDate: (date) => {
          return !this.dateMap.has(formatDate(date, 'yyyy-MM-dd'))
        }
      }
    },
    list() {
      return this.info.records || []
    }
  },
  watch: {
    'time.date': 'changeDate'
  },
  async created() {
    const baseInfo = await http({
      url: '/srmDeliveryAppoint/basicInfo',
      baseURL: process.env.VUE_APP_PURCHASE_API,
      data: {}
    })
    this.baseInfo = { ...baseInfo, dateList: Object.freeze(baseInfo.dateList || []) }
  },
  methods: {
    // 获取公司
    getPurchaseUnits() {
      return http({
        url: '/srmParkScheduling/getPurUnitInfo',
        baseURL: process.env.VUE_APP_PURCHASE_API,
        data: this.time
      })
    },
    // 获取仓库
    getReceiptWares() {
      return http({
        url: '/srmParkScheduling/getReceiptWare',
        baseURL: process.env.VUE_APP_PURCHASE_API,
        data: { ...this.time, purchaseUnitNo: this.purchaseUnitNo }
      })
    },
    // 更改预计到货日期
    async changeDate(value) {
      if (!value) {
        this.time.startTime = ''
        this.time.endTime = ''
        this.purchaseUnitNo = ''
        this.receiptWareId = ''
        this.timeOptions = []
        this.purchaseUnits = []
        this.receiptWares = []
        return
      }
      const [timeOptions, purchaseUnits, receiptWares] = await Promise.all([
        http({
          url: '/srmDeliveryAppoint/getPeriod',
          baseURL: process.env.VUE_APP_PURCHASE_API,
          data: { date: value }
        }),
        this.getPurchaseUnits(),
        this.getReceiptWares()
      ])
      this.timeOptions = Object.freeze(timeOptions || [])
      this.purchaseUnits = Object.freeze(purchaseUnits || [])
      this.receiptWares = Object.freeze(receiptWares || [])
      this.changeSearch()
    },
    // 更改开始时间
    async changeStartTime() {
      const [purchaseUnits, receiptWares] = await Promise.all([this.getPurchaseUnits(), this.getReceiptWares()])
      this.purchaseUnits = Object.freeze(purchaseUnits || [])
      this.receiptWares = Object.freeze(receiptWares || [])
      this.purchaseUnitNo = ''
      this.receiptWareId = ''
      this.changeSearch()
    },
    // 更改结束时间
    async changeEndTime() {
      const [purchaseUnits, receiptWares] = await Promise.all([this.getPurchaseUnits(), this.getReceiptWares()])
      this.purchaseUnits = Object.freeze(purchaseUnits || [])
      this.receiptWares = Object.freeze(receiptWares || [])
      this.purchaseUnitNo = ''
      this.receiptWareId = ''
      this.changeSearch()
    },
    // 跟改公司
    async changePurchaseUnitNo(purchaseUnitNo) {
      this.purchaseUnitNo = purchaseUnitNo
      const receiptWares = await this.getReceiptWares()
      this.receiptWares = Object.freeze(receiptWares || [])
      this.receiptWareId = ''
      this.changeSearch()
    },
    // 更改仓库
    async changeReceiptWareId(receiptWareId) {
      this.receiptWareId = receiptWareId
      this.changeSearch()
    },
    changeSearch() {
      this.current = 1
      this.search()
    },
    // 换页
    currentChange(current) {
      this.current = current
      this.search()
    },
    sizeChange(size) {
      this.size = size
      this.search()
    },
    // 搜索
    async search() {
      const params = {
        ...this.time,
        purchaseUnitNo: this.purchaseUnitNo,
        receiptWareId: this.receiptWareId
      }
      const data = await http({
        url: '/srmParkScheduling/getReservationParking',
        baseURL: process.env.VUE_APP_PURCHASE_API,
        data: { condition: params, current: this.current, size: this.size },
        loading: true
      })
      this.info = Object.freeze(data)
      this.total = this.info.total
    },
    // 更改车位
    changeCar(item) {
      const key = `${this.time.date} - ${item.parkingLotId}`
      const index = this.carSelection.indexOf(key)
      if (index === -1) {
        this.carSelection.push(key)
      } else {
        this.carSelection.splice(index, 1)
      }
    },
    async submit(perfect) {
      if (!this.selection.length) return this.$message({ message: this.$t('deliveryappointment.urgentreservation.requiredDetaillist'), type: 'warning' })
      console.log(this.baseInfo)
      const { appointUuid } = this.baseInfo
      const data = {
        appointUuid,
        dateList: this.selection.map(id => ({ id })),
        urgentSign: 'N'
      }
      await http({
        url: '/srmDeliveryAppoint/createReservation',
        baseURL: process.env.VUE_APP_PURCHASE_API,
        data: data,
        loading: true
      })
      if (perfect) {
        this.$router.push({ name: 'Myappointment.Myappointment.Perfect', params: { appointUuid }, query: { appointUuid }})
      } else {
        this.$router.back()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.appointment {
  &-header {
    background: #fff;
    padding: 10px;
  }
  &-top {
    padding-top: 10px;
    display: flex;
    align-content: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  &-tabs-list {
    padding: 10px 0;
  }

  &-list {
    display: flex;
    align-items: stretch;
    flex-wrap: wrap;
    padding: 10px 0;
  }
  &-footer {
    padding: 15px;
    background: #ffffff;
    text-align: right;
  }
  &::v-deep {
    .el-button--text {
      color: #333;
    }
  }
}
</style>
